import React from 'react';
import { connect } from 'react-redux';
import {
  Cookies,
} from '@resy/ui-kitchen';
import {
  fetchS3JsonFile, isSectionHidden, scrollTo, isGDAUser, identifyPageNameWithUrl,
} from '../AmexMarketingUtils/AmexUtils';
import { selectIsGlobalDiningAccess } from '../../../../../ui-kitchen/src/reducers/userSlice';
import { selectIsAuthenticated } from '../../../../../ui-kitchen/src/reducers/authTokenSlice';
import AmexLoading from '../AmexMarketingUtils/AmexLoading';
import AmexResyValueProps from './AmexResyValueProps';
import {
  FILE_NAME,
  FOLDER_NAME,
} from './constants';

import {
  CMT_COOKIE_NAME,
  GOLD_CARD,
} from '../AmexMarketingUtils/constants';

import { AMEX_RESY_VALUE } from '../../../../../ui-kitchen/src/constants/amexConstants';
import { setResyCreditCardTypes } from '../../../../../ui-kitchen/src/reducers/amexEventsSlice';
import AmexResyValueRelationship from './AmexResyValueRelationship';
import AmexResyValueFeaturedHighlights from './AmexResyValueFeaturedHighlights';
import AmexHeader from '../AmexMarketingUtils/AmexHeader';
import AmexBanner from '../AmexMarketingUtils/AmexBanner';
import AmexFlipComponent from '../AmexMarketingUtils/AmexFlipComponent';
import AmexNaaMgmComponent from '../AmexMarketingUtils/AmexNaaMgmComponent';
import AmexTerms from '../AmexMarketingUtils/AmexTerms';
import './AmexResyValue.scss';

class AmexResyValue extends React.Component {
  static propTypes = AmexResyValueProps;

  state = {
    contentData: {},
    hash: null,
  }

  componentDidMount() {
    const currentHash = (window.location.hash).replace('#', '');
    window.addEventListener('hashchange', this.handleHashChange, false);
    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
    } = this.props;
    this.fetchDataFile(baseRequestUrl, currentHash);
  }

  componentDidUpdate(prevProps, prevState) {
    const { hash, contentData } = this.state;
    if (prevState.hash !== hash) {
      window.location.hash = hash;
      if (hash) {
        setTimeout(() => {
          scrollTo(`#${hash}`);
        }, 1000);
      }
    }

    const {
      userDataInfo, isNonUS, isUserLoggedInAsGDA,
    } = this.props;

    if (prevProps?.userDataInfo !== userDataInfo
      || prevProps?.isNonUS !== isNonUS
      || prevProps?.isUserLoggedInAsGDA !== isUserLoggedInAsGDA
       || prevState?.contentData !== contentData) {
      this.isMGMNAAHidden(contentData, userDataInfo, isNonUS, isUserLoggedInAsGDA);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.handleHashChange, false);
  }

  isMGMNAAHidden = (contentData, userDataInfo, isNonUS, isUserLoggedInAsGDA) => {
    const {
      $location, $rootScope: {
        metadata,
      },
    } = this.props;
    const displayMGM = (Cookies.get(CMT_COOKIE_NAME) === GOLD_CARD)
    || (AMEX_RESY_VALUE === identifyPageNameWithUrl($location, metadata))
    || userDataInfo?.amex_card_types?.length > 0
    || isGDAUser(isUserLoggedInAsGDA, Cookies);

    const hideMGM = isSectionHidden(contentData, 'mgm') || isNonUS || !displayMGM;
    const hideNAA = isSectionHidden(contentData, 'naa') || isNonUS || displayMGM;
    this.setState({
      hideMGMState: hideMGM,
      hideNAAState: hideNAA,
    });
  }

  handleHashChange = () => {
    const currentLocationHash = (window.location.hash).replace('#', '');
    if (currentLocationHash && currentLocationHash !== '') {
      this.setState({ hash: currentLocationHash });
    }
  };

  fetchDataFile = async (baseRequestUrl, hash) => {
    const contentData = await fetchS3JsonFile(baseRequestUrl, FOLDER_NAME, FILE_NAME);
    this.setState({ contentData, hash });
    const { dispatch } = this.props;
    const { amex_card_types: amexCardTypes } = contentData;
    dispatch(setResyCreditCardTypes(amexCardTypes));
  }

  render() {
    const {
      $location,
      $rootScope,
      $rootScope: {
        matchMedia,
      },
      $routeParams,
      Analytics,
      isAuthenticated,
      isNonUS,
      ResyAmexConfig: {
        baseRequestUrl,
      },
    } = this.props;

    const {
      contentData,
      hash,
      hideMGMState,
      hideNAAState,
    } = this.state;

    if (Object.keys(contentData).length === 0) return <AmexLoading />;
    const {
      is_page_enabled: isPageEnabled,
      aws_folder_name: awsFolderName,
      event_tag: eventTag,
      tagging,
    } = contentData;

    if (!isPageEnabled) {
      // 404 error page
      window.location.pathname = '/404';
      return null;
    }

    return (
      <section className="AmexResyValue">
        <AmexHeader
          Analytics={Analytics}
          isAuthenticated={isAuthenticated}
          isNonUSLocation={isNonUS}
          $rootScope={$rootScope}
          $routeParams={$routeParams}
          $location={$location}
          matchMedia={matchMedia}
          resyHeaderConfig={contentData?.resy_header}
          tagConfig={tagging}
        />
        <AmexBanner
          awsFolderName={awsFolderName}
          baseRequestUrl={baseRequestUrl}
          bannerConfig={contentData?.banner}
          isExtended
          matchMedia={matchMedia}
        />
        {!isSectionHidden(contentData, 'welcome') && (
          <AmexFlipComponent
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            flipConfig={contentData?.welcome}
            Analytics={Analytics}
            matchMedia={matchMedia}
          />
        )}
        {!isSectionHidden(contentData, 'feature_highlights') && (
          <AmexResyValueFeaturedHighlights
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            Analytics={Analytics}
            matchMedia={matchMedia}
            eventTag={eventTag}
            sectionConfig={contentData?.feature_highlights}
          />
        )}
        {!isSectionHidden(contentData, 'relationship') && (
          <AmexResyValueRelationship
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            Analytics={Analytics}
            matchMedia={matchMedia}
            eventTag={eventTag}
            sectionConfig={contentData?.relationship}
          />
        )}
        {!hideMGMState && (
          <AmexNaaMgmComponent
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            matchMedia={matchMedia}
            sectionConfig={contentData?.mgm}
            eventAnalytics={Analytics.event}
            pageEventTag={eventTag}
          />
        )}
        {!hideNAAState && (
          <AmexNaaMgmComponent
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            matchMedia={matchMedia}
            sectionConfig={contentData?.naa}
            eventAnalytics={Analytics.event}
            pageEventTag={eventTag}
            isNAA
          />
        )}
        {!isSectionHidden(contentData, 'gift_card') && (
          <AmexFlipComponent
            awsFolderName={awsFolderName}
            baseRequestUrl={baseRequestUrl}
            flipConfig={contentData?.gift_card}
            Analytics={Analytics}
            matchMedia={matchMedia}
          />
        )}
        {!isSectionHidden(contentData, 'terms') && (
          <AmexTerms
            baseRequestUrl={baseRequestUrl}
            hash={hash}
            termsConfig={contentData?.terms}
            Analytics={Analytics}
          />
        )}
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: selectIsAuthenticated(state),
  isNonUS: state.ipdata?.isNonUS,
  userDataInfo: state.user?.userData,
  isUserLoggedInAsGDA: selectIsGlobalDiningAccess(state),
});

AmexResyValue.displayName = 'AmexResyValue';
export { AmexResyValue as ComponentAmexResyValueUnderTest, mapStateToProps };
export default connect(mapStateToProps)(AmexResyValue);
